import React from "react";
import { useSEO } from "@/hooks/useSEO";
import { PageHeader, CTASection } from "@/components/Sections";
import { Reveal, TechLabel } from "@/components/Reveal";
import { CONSTRUCTION } from "@/lib/site";

export default function Construction() {
  useSEO({
    title: "Construction | BlackSilex",
    description: "Spare and wear parts, pumps and components for construction — waste water management, tunneling and road construction, aggregate and quarries.",
    path: "/construction",
  });

  return (
    <div data-testid="construction-page">
      <PageHeader
        crumbs={[{ label: "Home", to: "/" }, { label: "Construction" }]}
        eyebrow="Industries / Construction"
        titleLines={["Construction."]}
      />

      <section className="max-w-[1600px] mx-auto px-6 lg:px-10 py-16 lg:py-24">
        <div className="border-t border-l border-offwhite/10 grid md:grid-cols-3">
          {CONSTRUCTION.map((ind, i) => (
            <Reveal key={ind.id} delay={i * 0.1}>
              <div id={ind.id} className="border-r border-b border-offwhite/10 p-8 lg:p-12 h-full scroll-mt-24" data-testid={`construction-${ind.id}`}>
                {ind.img && (
                  <div className="mb-8 -mx-8 -mt-8 lg:-mx-12 lg:-mt-12 overflow-hidden border-b border-offwhite/10">
                    <img src={ind.img} alt={ind.title} loading="lazy" decoding="async" className="w-full h-52 object-cover" data-testid={`construction-img-${ind.id}`} />
                  </div>
                )}
                <TechLabel>{ind.tag}</TechLabel>
                <h2 className="font-display font-black uppercase tracking-tight text-3xl md:text-4xl leading-[0.95] mt-6">{ind.title}</h2>
                {ind.copy && <p className="mt-6 text-mutedgray text-base leading-relaxed" data-testid={`construction-copy-${ind.id}`}>{ind.copy}</p>}
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CTASection />
    </div>
  );
}
